var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.14795H4.5C3.4 4.14795 2.5 5.04795 2.5 6.14795V18.1479C2.5 19.2479 3.4 20.1479 4.5 20.1479H20.5C21.6 20.1479 22.5 19.2479 22.5 18.1479V6.14795C22.5 5.04795 21.6 4.14795 20.5 4.14795ZM20.1 8.39795L13.56 12.4879C12.91 12.8979 12.09 12.8979 11.44 12.4879L4.9 8.39795C4.79973 8.34166 4.71192 8.26561 4.64189 8.1744C4.57186 8.0832 4.52106 7.97873 4.49258 7.86732C4.46409 7.75591 4.4585 7.63988 4.47616 7.52626C4.49381 7.41263 4.53434 7.30376 4.59528 7.20625C4.65623 7.10874 4.73632 7.02461 4.83073 6.95894C4.92513 6.89328 5.03187 6.84746 5.1445 6.82425C5.25712 6.80104 5.37328 6.80092 5.48595 6.8239C5.59863 6.84688 5.70546 6.89248 5.8 6.95795L12.5 11.1479L19.2 6.95795C19.2945 6.89248 19.4014 6.84688 19.514 6.8239C19.6267 6.80092 19.7429 6.80104 19.8555 6.82425C19.9681 6.84746 20.0749 6.89328 20.1693 6.95894C20.2637 7.02461 20.3438 7.10874 20.4047 7.20625C20.4657 7.30376 20.5062 7.41263 20.5238 7.52626C20.5415 7.63988 20.5359 7.75591 20.5074 7.86732C20.4789 7.97873 20.4281 8.0832 20.3581 8.1744C20.2881 8.26561 20.2003 8.34166 20.1 8.39795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9fcc9c871546210c67a2ef13f769e642.svg";
export { ForwardRef as ReactComponent };